module.exports = __webpack_public_path__ + "img/download.da2c3dec.png";